export const SEAT_SELECTION_TITLE = "Seat Selection";
export const SEAT_SELECTION_TITLE_V1 = "4. Select seats";
export const CONTINUE_CTA_TEXT = "Continue";
export const CONTINUE_CTA_TEXT_V1 = "Continue to payment";
export const SEAT_SELECTION_SUBTITLE =
  "Book seats ahead for your journey. If you decide to skip this step, seats will be assigned at check-in.";

export const SEAT_SELECTION_VALIDATION_MESSAGE =
  "Select your seats or skip seat selection to continue.";
